import { createSelector, createSlice } from "@reduxjs/toolkit";

const initialState = {
    memberDetails: {},
    status: 'idle',
    error: null
}

const memberDetailsSlice = createSlice({
    name: 'memberDetails',
    initialState,
    reducers: {
        setMemberDetails: (state, action) => {
            state.memberDetails = {
                ...state.memberDetails,
                ...action.payload,
            };
        },
        resetMemberDetails: () => initialState
    },
});


export const getMemberDetailsSelector = createSelector((state) => state?.memberDetails, (memberDetails) => memberDetails);
export const { setMemberDetails, resetMemberDetails } = memberDetailsSlice.actions
export default memberDetailsSlice.reducer;